export default "__VITE_ASSET__BERvPeU4__"